import { Link } from "gatsby";
import React from "react";

function TopNav2({ path }) {
  return (
    <>
      <div className="top--nav--two">
        <Link
          to="/"
          id="Home--top--link"
          className={`navigation--links ${
            path === "/" ? "active" : "not--active"
          }`}
        >
          Home
        </Link>
        <Link
          to="/designs"
          id="Design--top--link"
          className={`navigation--links ${
            path === "/designs" ||
            path === "/designs/" ||
            path === "/designjourney" ||
            path === "/designjourney/"
              ? "active"
              : "not--active"
          }`}
        >
          Design
        </Link>
        <Link
          to="/dev"
          id="Dev--top--link"
          className={`navigation--links ${
            path === "/dev" ||
            path === "/dev/" ||
            path === "/devjourney" ||
            path === "/devjourney/"
              ? "active"
              : "not--active"
          }`}
        >
          Dev
        </Link>
        <Link
          to="/about"
          id="About--top--link"
          className={`navigation--links ${
            path === "/about" || path === "/about/" ? "active" : "not--active"
          }`}
        >
          About
        </Link>
        <Link
          to="/contact"
          id="Contact--top--link"
          className={`navigation--links ${
            path === "/contact" || path === "/contact/"
              ? "active"
              : "not--active"
          }`}
        >
          Contact
        </Link>
      </div>
    </>
  );
}

export { TopNav2 };
